import {
  SECURITY_FETCH_STATUS_LOAD,
  SECURITY_FETCH_STATUS_SUCCEED,
  SECURITY_FETCH_STATUS_FAIL,
  SECURITY_TOTP_SETUP_LOAD,
  SECURITY_TOTP_SETUP_SUCCEED,
  SECURITY_TOTP_SETUP_FAIL,
  SECURITY_TOTP_VERIFY_LOAD,
  SECURITY_TOTP_VERIFY_SUCCEED,
  SECURITY_TOTP_VERIFY_FAIL,
  SECURITY_TOTP_DISABLE_LOAD,
  SECURITY_TOTP_DISABLE_SUCCEED,
  SECURITY_TOTP_DISABLE_FAIL,
  SECURITY_PASSKEY_LIST_LOAD,
  SECURITY_PASSKEY_LIST_SUCCEED,
  SECURITY_PASSKEY_LIST_FAIL,
  SECURITY_PASSKEY_ADD_LOAD,
  SECURITY_PASSKEY_ADD_SUCCEED,
  SECURITY_PASSKEY_ADD_FAIL,
  SECURITY_PASSKEY_DELETE_LOAD,
  SECURITY_PASSKEY_DELETE_SUCCEED,
  SECURITY_PASSKEY_DELETE_FAIL,
} from '../constants/actionTypes'

const initialState = {
  isLoading: false,
  error: null,
  totpEnabled: false,
  passkeyEnabled: false,
  totpSetupSecret: null,
  totpSetupOtpauth: null,
  passkeys: [],
  isAddingPasskey: false,
  isDeletingPasskey: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    // Status
    case SECURITY_FETCH_STATUS_LOAD:
      return { ...state, isLoading: true, error: null }
    case SECURITY_FETCH_STATUS_SUCCEED:
      return {
        ...state,
        isLoading: false,
        totpEnabled: action.totpEnabled,
        passkeyEnabled: action.passkeyEnabled,
      }
    case SECURITY_FETCH_STATUS_FAIL:
      return { ...state, isLoading: false, error: action.error }

    // TOTP Setup
    case SECURITY_TOTP_SETUP_LOAD:
      return { ...state, isLoading: true, error: null }
    case SECURITY_TOTP_SETUP_SUCCEED:
      return {
        ...state,
        isLoading: false,
        totpSetupSecret: action.secret,
        totpSetupOtpauth: action.otpauth,
      }
    case SECURITY_TOTP_SETUP_FAIL:
      return { ...state, isLoading: false, error: action.error }

    // TOTP Verify
    case SECURITY_TOTP_VERIFY_LOAD:
      return { ...state, isLoading: true, error: null }
    case SECURITY_TOTP_VERIFY_SUCCEED:
      return {
        ...state,
        isLoading: false,
        totpSetupSecret: null,
        totpSetupOtpauth: null,
      }
    case SECURITY_TOTP_VERIFY_FAIL:
      return { ...state, isLoading: false, error: action.error }

    // TOTP Disable
    case SECURITY_TOTP_DISABLE_LOAD:
      return { ...state, isLoading: true, error: null }
    case SECURITY_TOTP_DISABLE_SUCCEED:
      return { ...state, isLoading: false }
    case SECURITY_TOTP_DISABLE_FAIL:
      return { ...state, isLoading: false, error: action.error }

    // Passkey List
    case SECURITY_PASSKEY_LIST_LOAD:
      return { ...state, isLoading: true, error: null }
    case SECURITY_PASSKEY_LIST_SUCCEED:
      return { ...state, isLoading: false, passkeys: action.passkeys }
    case SECURITY_PASSKEY_LIST_FAIL:
      return { ...state, isLoading: false, error: action.error }

    // Passkey Add
    case SECURITY_PASSKEY_ADD_LOAD:
      return { ...state, isAddingPasskey: true, error: null }
    case SECURITY_PASSKEY_ADD_SUCCEED:
      return { ...state, isAddingPasskey: false }
    case SECURITY_PASSKEY_ADD_FAIL:
      return { ...state, isAddingPasskey: false, error: action.error }

    // Passkey Delete
    case SECURITY_PASSKEY_DELETE_LOAD:
      return { ...state, isDeletingPasskey: true, error: null }
    case SECURITY_PASSKEY_DELETE_SUCCEED:
      return { ...state, isDeletingPasskey: false }
    case SECURITY_PASSKEY_DELETE_FAIL:
      return { ...state, isDeletingPasskey: false, error: action.error }

    default:
      return state
  }
}

